type Props = {
  onClick?: any;
  id?: any;
  title?: any;
  className?: any;
  color?: any;
  icon?: any;
  text?: any;
  children?: any;
  hovertext?: any;
  bordersize?: any;
  hoverbg?: any;
  hoverbordercolor?: any;
  loader?: any;
  childCSS?: any;
  disabledcss?: any;
  disabled?: boolean;
};
const Button = ({
  onClick,
  id,
  title,
  className,
  color,
  icon,
  text,
  children,
  hovertext,
  bordersize,
  hoverbg,
  hoverbordercolor,
  loader,
  childCSS,
  disabledcss,
  disabled = false,
}: Props) => {
  return (
    <>
      <button
        onClick={onClick}
        disabled={disabled}
        id={id}
        data-title={title}
        className={`${className} 
            border-${color} ${bordersize} ${hovertext} ${disabledcss} ml-1  font-bold px-3 py-2  mr-1 mb-1 active:bg-${color}-600 ${hoverbg} ${hoverbordercolor} uppercase text-sm shadow hover:shadow-lg
            flex items-center text-center tracking-wide transition-colors duration-200 transform rounded-md`}
      >
        {icon}
        <div className={`flex items-center ${childCSS}`}>
          {children}
          {text}
        </div>
      </button>
    </>
  );
};

Button.defaultProps = {
  color: "rose",
  className: "w-full text-gray-900",
  hovertext: "",
  bordersize: "border-2",
  hoverbg: "",
  hoverbordercolor: "",
  childCSS: "",
  disabledcss: "disabled:bg-gray-400",
};

export { Button };
